import { render } from "./app-header-account-sets.vue?vue&type=template&id=687a72c5"
import script from "./app-header-account-sets.vue?vue&type=script&lang=js"
export * from "./app-header-account-sets.vue?vue&type=script&lang=js"

import "./app-header-account-sets.vue?vue&type=style&index=0&id=687a72c5&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__